import PropTypes from 'prop-types';

import { Button } from '@hivebrite/design-system/Button';
import {
  FontAwesomeIcon,
  CATEGORIES,
} from '@hivebrite/design-system/FontAwesomeIcon';

const JoinButton = ({ onClick, isLoading, requestIsPending = false }) => (
  <Button
    aria-label={
      requestIsPending
        ? s__('Accessibility|Request to join the group is pending')
        : s__('Accessibility|Join the group')
    }
    isLoading={isLoading}
    onClick={onClick}
    icon={
      requestIsPending
        ? () => (
            <FontAwesomeIcon
              height="16px"
              iconType={CATEGORIES.SOLID}
              iconName="clock"
            />
          )
        : undefined
    }
  >
    {requestIsPending
      ? s__('Topics|Pending request')
      : I18n.t('web.groups.follow')}
  </Button>
);

JoinButton.propTypes = {
  onClick: PropTypes.func,
  requestIsPending: PropTypes.bool,
};

export default JoinButton;
